import { CheckOutlined } from '@ant-design/icons'
import { Button, Popconfirm, notification } from 'antd'
import { FC } from 'react'
import { useUpdateTaskMutation } from '../../store/api/tasks-api'
import useErrorModal from '../../hooks/api/use-error-modal'
import Task from '../../types/api/task'

interface CompleteDigitalDismountingTaskProps {
    task: Task
}

const CompleteDigitalDismountingTask: FC<CompleteDigitalDismountingTaskProps> = ({ task }) => {
    const [updateTask, updateTaskState] = useUpdateTaskMutation()

    useErrorModal(updateTaskState, 'Не удалось завершить задачу')

    if (task.taskStatus === 'Отменена') {
        return null
    }

    const isCompleted = task.taskStatus === 'Завершена'

    const onConfirm = async () => {
        const result = await updateTask({
            docId: task.documentId,
            body: { data: { taskStatus: 'Завершена' } },
        })

        if (result.data) {
            notification.success({ message: 'Задача завершена' })
        }
    }

    return (
        <Popconfirm
            title='Завершить задачу?'
            okText='Да'
            cancelText='Нет'
            onConfirm={onConfirm}
        >
            <Button type='primary' size='middle' loading={updateTaskState.isLoading} disabled={isCompleted}>
                Завершить
            </Button>
        </Popconfirm>
    )
}

export default CompleteDigitalDismountingTask
